import { convertStyleData, transformPx2Rem } from '@utils/tools';
import { appMethod as app } from '@utils/app';

import { ImgUpload } from '@common/img-upload/ImgUpload';

import './UploadImgCustomComponent.less';

export default function UploadImgCustomComponent(props) {
  /**
   * 传入数据
   */ 
  const data = props.data;                // 组件数据
  const dynamicData = props.dynamicData;  // 动态数据
  const formCompindex = props.formCompindex;    // 动态表单索引
  const form_data = props.form_data || {};      // 动态表单传入数据
  /**
   * 组件配置对象
   */  
  const customFeature = data.customFeature;
  const segment = customFeature.segment;
  /**
   * 样式数据处理
   */
  const styleObj = convertStyleData(data.style);
  styleObj['padding'] = transformPx2Rem('15px', 320);

  /**
   * 绑定事件
   */
  const uploadFormImg = (url) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex    = props.index;
    let formcompindex = formCompindex;
    let segment      = customFeature.segment;
    let datakey = `eles[${formcompindex}].form_data.${customFeature.segment}`;

    let hasImgList = form_data[segment] || [];
    let newdata = {};
    newdata[datakey] = [...hasImgList, url];
    pageInstance.setData(newdata);
  }
  const noBindSegment = () => {
    app.showModal({
      content: '该组件【添加图片】未绑定字段 请在电脑编辑页绑定后使用'
    })
  }
  const deleteUploadImg = (index) => {
    let pageInstance = app.getAppCurrentPage();
    let formcompindex = formCompindex;
    let datakey = `eles[${formcompindex}].form_data.${customFeature.segment}`;
    app.showModal({
      content: '确定删除该图片？',
      showCancel: true,
      confirm: function () {
        let newdata = {};
        form_data[segment].splice(index, 1);
        newdata[datakey] = form_data[segment];
        pageInstance.setData(newdata);
      }
    })
  }
  const tapPrevewPictureHandler = (event) => {
    app.tapPrevewPictureHandler(event);
  }
  /**
   * 返回组件
   */ 
  return (
    <div className={`custom-component upload-img ${data.segment_required ? 'must' : ''}`} style={styleObj}>
      {
        form_data[segment] &&
        form_data[segment].map((item, index) => (
          <div key={item} className="has-upload-img">
            <div className="ico-moon icon-closes delete-img" onClick={() => deleteUploadImg(index)}></div>
            <img src={item} 
              onClick={tapPrevewPictureHandler}
              data-img={item.pic}
              data-imgarr={JSON.stringify(form_data[segment])}/>
          </div>
        ))
      }
      {
        (!form_data[segment] || form_data[segment].length < (customFeature.upImageCount || 9)) &&
        <div className="plus-div" >
          <span>+</span>
          <div>添加图片</div>
          {
            segment &&
            <ImgUpload complete={(url) => uploadFormImg(url)}/>
          }
          {
            !segment &&
            <div className="no-bind" onClick={noBindSegment}></div>
          }
        </div>
      }
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/upload-img-custom-component/UploadImgCustomComponent.jsx